import type { Lesson } from "../types/chapters";

export const LESSON_STUBS: Lesson[] = [
  {
    "id": "varnamala",
    "fileName": "varnamala.txt",
    "title": "वर्णमाला · Alphabet & Syllables",
    "sentences": [
      {
        "sanskrit": "स्वराः — Vowels",
        "meaning": "स्वराः — Vowels",
        "words": [
          "अ",
          "आ",
          "इ",
          "ई",
          "उ",
          "ऊ",
          "ऋ",
          "ॠ",
          "ऌ",
          "ए",
          "ऐ",
          "ओ",
          "औ"
        ],
        "category": "स्वराः"
      },
      {
        "sanskrit": "क-वर्ग — Velars",
        "meaning": "क-वर्ग — Velars",
        "words": [
          "क",
          "ख",
          "ग",
          "घ",
          "ङ"
        ],
        "category": "क-वर्गः"
      },
      {
        "sanskrit": "च-वर्ग — Palatals",
        "meaning": "च-वर्ग — Palatals",
        "words": [
          "च",
          "छ",
          "ज",
          "झ",
          "ञ"
        ],
        "category": "च-वर्गः"
      },
      {
        "sanskrit": "ट-वर्ग — Retroflexes",
        "meaning": "ट-वर्ग — Retroflexes",
        "words": [
          "ट",
          "ठ",
          "ड",
          "ढ",
          "ण"
        ],
        "category": "ट-वर्गः"
      },
      {
        "sanskrit": "त-वर्ग — Dentals",
        "meaning": "त-वर्ग — Dentals",
        "words": [
          "त",
          "थ",
          "द",
          "ध",
          "न"
        ],
        "category": "त-वर्गः"
      },
      {
        "sanskrit": "प-वर्ग — Labials",
        "meaning": "प-वर्ग — Labials",
        "words": [
          "प",
          "फ",
          "ब",
          "भ",
          "म"
        ],
        "category": "प-वर्गः"
      },
      {
        "sanskrit": "अन्तःस्थ व्यञ्जनानि — Semivowels",
        "meaning": "अन्तःस्थ व्यञ्जनानि — Semivowels",
        "words": [
          "य",
          "र",
          "ल",
          "व"
        ],
        "category": "अन्तःस्थाः"
      },
      {
        "sanskrit": "ऊष्माणि — Sibilants and Aspirate",
        "meaning": "ऊष्माणि — Sibilants and Aspirate",
        "words": [
          "श",
          "ष",
          "स",
          "ह"
        ],
        "category": "ऊष्माणः"
      },
      {
        "sanskrit": "अं / अः — Anusvāra & Visarga",
        "meaning": "अं / अः — Anusvāra & Visarga",
        "words": [
          "अं",
          "अः",
          "अँ"
        ],
        "category": "अनुस्वार"
      },
      {
        "sanskrit": "संयुक्तवत् — Conjuncts",
        "meaning": "संयुक्तवत् — Conjuncts",
        "words": [
          "क्ष",
          "ज्ञ",
          "त्र",
          "श्र"
        ],
        "category": "संयुक्तवत्"
      }
    ]
  },
  {
    "id": "barakhadi",
    "fileName": "barakhadi.txt",
    "title": "बारहखड़ी · Audio Lesson",
    "sentences": [
      {
        "sanskrit": "Velars · क-row · tap to hear",
        "meaning": "Velars · क-row · tap to hear",
        "words": [
          "क",
          "का",
          "कि",
          "की",
          "कु",
          "कू",
          "कृ",
          "के",
          "कै",
          "को",
          "कौ",
          "कं",
          "कः"
        ],
        "category": "क"
      },
      {
        "sanskrit": "Velars · ख-row · tap to hear",
        "meaning": "Velars · ख-row · tap to hear",
        "words": [
          "ख",
          "खा",
          "खि",
          "खी",
          "खु",
          "खू",
          "खृ",
          "खे",
          "खै",
          "खो",
          "खौ",
          "खं",
          "खः"
        ],
        "category": "ख"
      },
      {
        "sanskrit": "Velars · ग-row · tap to hear",
        "meaning": "Velars · ग-row · tap to hear",
        "words": [
          "ग",
          "गा",
          "गि",
          "गी",
          "गु",
          "गू",
          "गृ",
          "गे",
          "गै",
          "गो",
          "गौ",
          "गं",
          "गः"
        ],
        "category": "ग"
      },
      {
        "sanskrit": "Velars · घ-row · tap to hear",
        "meaning": "Velars · घ-row · tap to hear",
        "words": [
          "घ",
          "घा",
          "घि",
          "घी",
          "घु",
          "घू",
          "घृ",
          "घे",
          "घै",
          "घो",
          "घौ",
          "घं",
          "घः"
        ],
        "category": "घ"
      },
      {
        "sanskrit": "Velars · ङ-row · tap to hear",
        "meaning": "Velars · ङ-row · tap to hear",
        "words": [
          "ङ",
          "ङा",
          "ङि",
          "ङी",
          "ङु",
          "ङू",
          "ङृ",
          "ङे",
          "ङै",
          "ङो",
          "ङौ",
          "ङं",
          "ङः"
        ],
        "category": "ङ"
      },
      {
        "sanskrit": "Palatals · च-row · tap to hear",
        "meaning": "Palatals · च-row · tap to hear",
        "words": [
          "च",
          "चा",
          "चि",
          "ची",
          "चु",
          "चू",
          "चृ",
          "चे",
          "चै",
          "चो",
          "चौ",
          "चं",
          "चः"
        ],
        "category": "च"
      },
      {
        "sanskrit": "Palatals · छ-row · tap to hear",
        "meaning": "Palatals · छ-row · tap to hear",
        "words": [
          "छ",
          "छा",
          "छि",
          "छी",
          "छु",
          "छू",
          "छृ",
          "छे",
          "छै",
          "छो",
          "छौ",
          "छं",
          "छः"
        ],
        "category": "छ"
      },
      {
        "sanskrit": "Palatals · ज-row · tap to hear",
        "meaning": "Palatals · ज-row · tap to hear",
        "words": [
          "ज",
          "जा",
          "जि",
          "जी",
          "जु",
          "जू",
          "जृ",
          "जे",
          "जै",
          "जो",
          "जौ",
          "जं",
          "जः"
        ],
        "category": "ज"
      },
      {
        "sanskrit": "Palatals · झ-row · tap to hear",
        "meaning": "Palatals · झ-row · tap to hear",
        "words": [
          "झ",
          "झा",
          "झि",
          "झी",
          "झु",
          "झू",
          "झृ",
          "झे",
          "झै",
          "झो",
          "झौ",
          "झं",
          "झः"
        ],
        "category": "झ"
      },
      {
        "sanskrit": "Palatals · ञ-row · tap to hear",
        "meaning": "Palatals · ञ-row · tap to hear",
        "words": [
          "ञ",
          "ञा",
          "ञि",
          "ञी",
          "ञु",
          "ञू",
          "ञृ",
          "ञे",
          "ञै",
          "ञो",
          "ञौ",
          "ञं",
          "ञः"
        ],
        "category": "ञ"
      },
      {
        "sanskrit": "Retroflexes · ट-row · tap to hear",
        "meaning": "Retroflexes · ट-row · tap to hear",
        "words": [
          "ट",
          "टा",
          "टि",
          "टी",
          "टु",
          "टू",
          "टृ",
          "टे",
          "टै",
          "टो",
          "टौ",
          "टं",
          "टः"
        ],
        "category": "ट"
      },
      {
        "sanskrit": "Retroflexes · ठ-row · tap to hear",
        "meaning": "Retroflexes · ठ-row · tap to hear",
        "words": [
          "ठ",
          "ठा",
          "ठि",
          "ठी",
          "ठु",
          "ठू",
          "ठृ",
          "ठे",
          "ठै",
          "ठो",
          "ठौ",
          "ठं",
          "ठः"
        ],
        "category": "ठ"
      },
      {
        "sanskrit": "Retroflexes · ड-row · tap to hear",
        "meaning": "Retroflexes · ड-row · tap to hear",
        "words": [
          "ड",
          "डा",
          "डि",
          "डी",
          "डु",
          "डू",
          "डृ",
          "डे",
          "डै",
          "डो",
          "डौ",
          "डं",
          "डः"
        ],
        "category": "ड"
      },
      {
        "sanskrit": "Retroflexes · ढ-row · tap to hear",
        "meaning": "Retroflexes · ढ-row · tap to hear",
        "words": [
          "ढ",
          "ढा",
          "ढि",
          "ढी",
          "ढु",
          "ढू",
          "ढृ",
          "ढे",
          "ढै",
          "ढो",
          "ढौ",
          "ढं",
          "ढः"
        ],
        "category": "ढ"
      },
      {
        "sanskrit": "Retroflexes · ण-row · tap to hear",
        "meaning": "Retroflexes · ण-row · tap to hear",
        "words": [
          "ण",
          "णा",
          "णि",
          "णी",
          "णु",
          "णू",
          "णृ",
          "णे",
          "णै",
          "णो",
          "णौ",
          "णं",
          "णः"
        ],
        "category": "ण"
      },
      {
        "sanskrit": "Dentals · त-row · tap to hear",
        "meaning": "Dentals · त-row · tap to hear",
        "words": [
          "त",
          "ता",
          "ति",
          "ती",
          "तु",
          "तू",
          "तृ",
          "ते",
          "तै",
          "तो",
          "तौ",
          "तं",
          "तः"
        ],
        "category": "त"
      },
      {
        "sanskrit": "Dentals · थ-row · tap to hear",
        "meaning": "Dentals · थ-row · tap to hear",
        "words": [
          "थ",
          "था",
          "थि",
          "थी",
          "थु",
          "थू",
          "थृ",
          "थे",
          "थै",
          "थो",
          "थौ",
          "थं",
          "थः"
        ],
        "category": "थ"
      },
      {
        "sanskrit": "Dentals · द-row · tap to hear",
        "meaning": "Dentals · द-row · tap to hear",
        "words": [
          "द",
          "दा",
          "दि",
          "दी",
          "दु",
          "दू",
          "दृ",
          "दे",
          "दै",
          "दो",
          "दौ",
          "दं",
          "दः"
        ],
        "category": "द"
      },
      {
        "sanskrit": "Dentals · ध-row · tap to hear",
        "meaning": "Dentals · ध-row · tap to hear",
        "words": [
          "ध",
          "धा",
          "धि",
          "धी",
          "धु",
          "धू",
          "धृ",
          "धे",
          "धै",
          "धो",
          "धौ",
          "धं",
          "धः"
        ],
        "category": "ध"
      },
      {
        "sanskrit": "Dentals · न-row · tap to hear",
        "meaning": "Dentals · न-row · tap to hear",
        "words": [
          "न",
          "ना",
          "नि",
          "नी",
          "नु",
          "नू",
          "नृ",
          "ने",
          "नै",
          "नो",
          "नौ",
          "नं",
          "नः"
        ],
        "category": "न"
      },
      {
        "sanskrit": "Labials · प-row · tap to hear",
        "meaning": "Labials · प-row · tap to hear",
        "words": [
          "प",
          "पा",
          "पि",
          "पी",
          "पु",
          "पू",
          "पृ",
          "पे",
          "पै",
          "पो",
          "पौ",
          "पं",
          "पः"
        ],
        "category": "प"
      },
      {
        "sanskrit": "Labials · फ-row · tap to hear",
        "meaning": "Labials · फ-row · tap to hear",
        "words": [
          "फ",
          "फा",
          "फि",
          "फी",
          "फु",
          "फू",
          "फृ",
          "फे",
          "फै",
          "फो",
          "फौ",
          "फं",
          "फः"
        ],
        "category": "फ"
      },
      {
        "sanskrit": "Labials · ब-row · tap to hear",
        "meaning": "Labials · ब-row · tap to hear",
        "words": [
          "ब",
          "बा",
          "बि",
          "बी",
          "बु",
          "बू",
          "बृ",
          "बे",
          "बै",
          "बो",
          "बौ",
          "बं",
          "बः"
        ],
        "category": "ब"
      },
      {
        "sanskrit": "Labials · भ-row · tap to hear",
        "meaning": "Labials · भ-row · tap to hear",
        "words": [
          "भ",
          "भा",
          "भि",
          "भी",
          "भु",
          "भू",
          "भृ",
          "भे",
          "भै",
          "भो",
          "भौ",
          "भं",
          "भः"
        ],
        "category": "भ"
      },
      {
        "sanskrit": "Labials · म-row · tap to hear",
        "meaning": "Labials · म-row · tap to hear",
        "words": [
          "म",
          "मा",
          "मि",
          "मी",
          "मु",
          "मू",
          "मृ",
          "मे",
          "मै",
          "मो",
          "मौ",
          "मं",
          "मः"
        ],
        "category": "म"
      },
      {
        "sanskrit": "Semi-vowels · य-row · tap to hear",
        "meaning": "Semi-vowels · य-row · tap to hear",
        "words": [
          "य",
          "या",
          "यि",
          "यी",
          "यु",
          "यू",
          "यृ",
          "ये",
          "यै",
          "यो",
          "यौ",
          "यं",
          "यः"
        ],
        "category": "य"
      },
      {
        "sanskrit": "Semi-vowels · र-row · tap to hear",
        "meaning": "Semi-vowels · र-row · tap to hear",
        "words": [
          "र",
          "रा",
          "रि",
          "री",
          "रु",
          "रू",
          "रृ",
          "रे",
          "रै",
          "रो",
          "रौ",
          "रं",
          "रः"
        ],
        "category": "र"
      },
      {
        "sanskrit": "Semi-vowels · ल-row · tap to hear",
        "meaning": "Semi-vowels · ल-row · tap to hear",
        "words": [
          "ल",
          "ला",
          "लि",
          "ली",
          "लु",
          "लू",
          "लृ",
          "ले",
          "लै",
          "लो",
          "लौ",
          "लं",
          "लः"
        ],
        "category": "ल"
      },
      {
        "sanskrit": "Semi-vowels · व-row · tap to hear",
        "meaning": "Semi-vowels · व-row · tap to hear",
        "words": [
          "व",
          "वा",
          "वि",
          "वी",
          "वु",
          "वू",
          "वृ",
          "वे",
          "वै",
          "वो",
          "वौ",
          "वं",
          "वः"
        ],
        "category": "व"
      },
      {
        "sanskrit": "Sibilants & ह · श-row · tap to hear",
        "meaning": "Sibilants & ह · श-row · tap to hear",
        "words": [
          "श",
          "शा",
          "शि",
          "शी",
          "शु",
          "शू",
          "शृ",
          "शे",
          "शै",
          "शो",
          "शौ",
          "शं",
          "शः"
        ],
        "category": "श"
      },
      {
        "sanskrit": "Sibilants & ह · ष-row · tap to hear",
        "meaning": "Sibilants & ह · ष-row · tap to hear",
        "words": [
          "ष",
          "षा",
          "षि",
          "षी",
          "षु",
          "षू",
          "षृ",
          "षे",
          "षै",
          "षो",
          "षौ",
          "षं",
          "षः"
        ],
        "category": "ष"
      },
      {
        "sanskrit": "Sibilants & ह · स-row · tap to hear",
        "meaning": "Sibilants & ह · स-row · tap to hear",
        "words": [
          "स",
          "सा",
          "सि",
          "सी",
          "सु",
          "सू",
          "सृ",
          "से",
          "सै",
          "सो",
          "सौ",
          "सं",
          "सः"
        ],
        "category": "स"
      },
      {
        "sanskrit": "Sibilants & ह · ह-row · tap to hear",
        "meaning": "Sibilants & ह · ह-row · tap to hear",
        "words": [
          "ह",
          "हा",
          "हि",
          "ही",
          "हु",
          "हू",
          "हृ",
          "हे",
          "है",
          "हो",
          "हौ",
          "हं",
          "हः"
        ],
        "category": "ह"
      }
    ]
  },
  {
    "id": "samyukta",
    "fileName": "samyukta.txt",
    "title": "संयुक्त · Conjunct Games",
    "sentences": [
      {
        "sanskrit": "स + त → स्त",
        "meaning": "Game 1 · Drop the Stick",
        "words": [],
        "category": "game1"
      },
      {
        "sanskrit": "द + व → द्व",
        "meaning": "Game 2 · Piggyback Ride",
        "words": [],
        "category": "game2"
      },
      {
        "sanskrit": "क्+ष / त्+र",
        "meaning": "Game 3 · Superhero Shape-Shifters",
        "words": [],
        "category": "game3"
      }
    ]
  },
  {
    "id": "numbers",
    "fileName": "numbers.txt",
    "title": "Sanskrit Numbers Guide (संख्या)",
    "sentences": [
      {
        "sanskrit": "प्रथमावलिः : १ तः १० पर्यन्तम् (Numbers 1 to 10: The foundational digits).",
        "meaning": "Numbers 1-10 (१-१०)",
        "words": [
          "० - शून्यम्",
          "१ - एकम्",
          "२ - द्वे",
          "३ - त्रीणि",
          "४ - चत्वारी",
          "५ - पञ्च",
          "६ - षट्",
          "७ - सप्त",
          "८ - अष्ट",
          "९ - नव",
          "१० - दश"
        ],
        "category": "प्रथमावलिः"
      },
      {
        "sanskrit": "द्वितीयावलिः : ११ तः २० पर्यन्तम् (Numbers 11 to 20: Mastery milestones).",
        "meaning": "Numbers 11-20 (११-२०)",
        "words": [
          "११ - एकादश",
          "१२ - द्वादश",
          "१३ - त्रयोदश",
          "१४ - चतुर्दश",
          "१५ - पञ्चदश",
          "१६ - षोडश",
          "१७ - सप्तदश",
          "१८ - अष्टादश",
          "१९ - नवदश",
          "२० - विंशतिः"
        ],
        "category": "द्वितीयावलिः"
      }
    ]
  },
  {
    "id": "simple-sentences",
    "fileName": "simple-sentences.txt",
    "title": "सरल-वाक्यानि एवं धातवः · Simple Sentences & Root Words",
    "page_numbers": "1",
    "sentences": [
      {
        "sanskrit": "बालकः पुस्तकं पठति।",
        "meaning": "The boy reads the book.",
        "words": ["बालकः", "पुस्तकम्", "पठति"],
        "category": "त्रिपद-वाक्यानि"
      },
      {
        "sanskrit": "बालिका पत्रं लिखति।",
        "meaning": "The girl writes a letter.",
        "words": ["बालिका", "पत्रम्", "लिखति"],
        "category": "त्रिपद-वाक्यानि"
      },
      {
        "sanskrit": "अहं विद्यालयं गच्छामि।",
        "meaning": "I go to school.",
        "words": ["अहम्", "विद्यालयम्", "गच्छामि"],
        "category": "दैनिक-सम्भाषणम्"
      },
      {
        "sanskrit": "सूर्यः आकाशे उदयति।",
        "meaning": "The sun rises in the sky.",
        "words": ["सूर्यः", "आकाशे", "उदयति"],
        "category": "प्रकृतिः"
      },
      {
        "sanskrit": "पठ् ➔ पठति (reads)",
        "meaning": "Root word paṭh (to read) transforms to paṭhati (reads).",
        "words": ["पठ्", "पठति", "पठामि"],
        "category": "धातवः"
      }
    ]
  },
  {
    "id": "gsde101",
    "fileName": "gsde101.txt",
    "title": "Chapter 1: वन्दे भारतमातरम् (पाठः पृष्ठानि १-७)",
    "page_numbers": "1-7",
    "sentences": []
  },
  {
    "id": "gsde102",
    "fileName": "gsde102.txt",
    "title": "Chapter 2: नित्यं पिबामः सुभाषितरसम (पाठः पृष्ठानि १५-२१)",
    "page_numbers": "15-27",
    "sentences": []
  },
  {
    "id": "gsde103",
    "fileName": "gsde103.txt",
    "title": "Chapter 3: मित्राय नमः (पाठः पृष्ठानि २९-३१)",
    "page_numbers": "29-38",
    "sentences": []
  },
  {
    "id": "gsde104",
    "fileName": "gsde104.txt",
    "title": "Chapter 4: न लभ्यते चेत् आम्लं द्राक्षाफलम् (पाठः पृष्ठानि ३९-४१)",
    "page_numbers": "39-45",
    "sentences": []
  },
  {
    "id": "gsde105",
    "fileName": "gsde105.txt",
    "title": "Chapter 5: सेवा हि परमो धर्मः (पाठः पृष्ठानि ४७-५०)",
    "page_numbers": "47-50",
    "sentences": []
  },
  {
    "id": "gsde106",
    "fileName": "gsde106.txt",
    "title": "Chapter 6: क्रीडाम वयं श्लोकान्त्याक्षरीम् (पाठः पृष्ठानि ५७–६३ · अभ्यासः पृष्ठानि ६४–७०)",
    "page_numbers": "",
    "sentences": []
  },
  {
    "id": "gsde107",
    "fileName": "gsde107.txt",
    "title": "Chapter 7: ईशावास्यम् इदं सर्वम् (पाठः पृष्ठानि ७१–७५ · अभ्यासः पृष्ठानि ७६–८४)",
    "page_numbers": "",
    "sentences": []
  },
  {
    "id": "gsde108",
    "fileName": "gsde108.txt",
    "title": "Chapter 8: हितं मनोहारि च दुर्लभं वचः (पाठः पृष्ठानि ८५–९० · अभ्यासः पृष्ठानि ९१–९५)",
    "page_numbers": "85-95",
    "sentences": []
  },
  {
    "id": "gsde109",
    "fileName": "gsde109.txt",
    "title": "Chapter 9: अन्नाद् भवन्ति भूतानि (पाठः पृष्ठानि ९६–९८ · अभ्यासः पृष्ठानि ९९–१०३)",
    "page_numbers": "96-103",
    "sentences": []
  },
  {
    "id": "gsde110",
    "fileName": "gsde110.txt",
    "title": "Chapter 10: दशमः कः? (पाठः पृष्ठानि १०४–१०७ · अभ्यासः पृष्ठानि १०८–११४)",
    "page_numbers": "104-114",
    "sentences": []
  },
  {
    "id": "gsde111",
    "fileName": "gsde111.txt",
    "title": "Chapter 11: एकादशः पाठः : द्वीपेषु रम्यः द्वीपोऽण्डमानः",
    "page_numbers": "115-126",
    "sentences": []
  },
  {
    "id": "gsde112",
    "fileName": "gsde112.txt",
    "title": "Chapter 12: द्वादशः पाठः : वीराङ्गना पन्नाधाया",
    "page_numbers": "127-136",
    "sentences": []
  },
  {
    "id": "gsde113",
    "fileName": "gsde113.txt",
    "title": "Chapter 13: अतिरिक्तम् अध्ययनम् : वर्णमात्रा-परिचयः",
    "page_numbers": "137-148",
    "sentences": []
  },
  {
    "id": "gsde114",
    "fileName": "gsde114.txt",
    "title": "Chapter 14: परिशिष्टम् १ — शब्दरूपाणि",
    "page_numbers": "",
    "sentences": []
  },
  {
    "id": "gsde115",
    "fileName": "gsde115.txt",
    "title": "Chapter 15: परिशिष्टम् २ — धातुरूपाणि",
    "page_numbers": "",
    "sentences": []
  },
  {
    "id": "grade8_prarthana",
    "fileName": "grade8_prarthana.txt",
    "title": "Grade 8: मङ्गलाचरणम् — सरस्वतीप्रार्थना एवं राष्ट्र-गानम्",
    "page_numbers": "Pages 8 & xvi",
    "sentences": []
  },
  {
    "id": "grade8_ch1",
    "fileName": "grade8_ch1.txt",
    "title": "Grade 8: प्रथमः पाठः — संगच्छध्वं संवदध्वम् (Pages 1–9)",
    "page_numbers": "Pages 1–9",
    "sentences": []
  },
  {
    "id": "grade8_ch2",
    "fileName": "grade8_ch2.txt",
    "title": "Grade 8: द्वितीयः पाठः — अल्पानामपि वस्तूनां संहतिः कार्यसाधिका (Pages 10–22)",
    "page_numbers": "10-22",
    "sentences": []
  },
  {
    "id": "grade8_ch3",
    "fileName": "grade8_ch3.txt",
    "title": "तृतीयः पाठः — सुभाषितरसं पीत्वा जीवनं सफलं कुरु",
    "page_numbers": "Pages 24–35",
    "sentences": []
  },
  {
    "id": "grade8_ch4",
    "fileName": "grade8_ch4.txt",
    "title": "चतुर्थः पाठः — प्रणम्यो देशभक्तोऽयं गोपबन्धुर्महामनाः",
    "page_numbers": "Pages 36–45",
    "sentences": []
  },
  {
    "id": "grade8_ch5",
    "fileName": "grade8_ch5.txt",
    "title": "पञ्चमः पाठः — गीता सुगीता कर्तव्या",
    "page_numbers": "49-58",
    "sentences": []
  },
  {
    "id": "grade8_ch6",
    "fileName": "grade8_ch6.txt",
    "title": "षष्ठः पाठः — डिजिभारतम् – युगपरिवर्तनम्",
    "page_numbers": "Pages 61–71",
    "sentences": []
  },
  {
    "id": "grade8_ch7",
    "fileName": "grade8_ch7.txt",
    "title": "सप्तमः पाठः — मञ्जुलमञ्जूषा सुन्दरसुरभाषा",
    "page_numbers": "75–84",
    "sentences": []
  },
  {
    "id": "grade8_ch8",
    "fileName": "grade8_ch8.txt",
    "title": "अष्टमः पाठः — पश्यत कोणमैशान्यं भारतस्य मनोहरम्",
    "page_numbers": "85–94",
    "sentences": []
  },
  {
    "id": "grade8_ch9",
    "fileName": "grade8_ch9.txt",
    "title": "नवमः पाठः — कोऽरुक् ? कोऽरुक् ? कोऽरुक् ?",
    "page_numbers": "62–65 / 97–105",
    "sentences": []
  },
  {
    "id": "grade8_ch10",
    "fileName": "grade8_ch10.txt",
    "title": "दशमः पाठः — सन्निमित्ते वरं त्यागः (क-भागः)",
    "page_numbers": "111–122",
    "sentences": []
  },
  {
    "id": "grade8_ch11",
    "fileName": "grade8_ch11.txt",
    "title": "एकादशः पाठः — सन्निमित्ते वरं त्यागः (ख-भागः)",
    "page_numbers": "124–135",
    "sentences": []
  },
  {
    "id": "grade8_ch12",
    "fileName": "grade8_ch12.txt",
    "title": "द्वादशः पाठः — सम्यग्वर्णप्रयोगेण ब्रह्मलोके महीयते",
    "page_numbers": "137–146",
    "sentences": []
  },
  {
    "id": "grade8_ch13",
    "fileName": "grade8_ch13.txt",
    "title": "त्रयोदशः पाठः — वर्णोच्चारण-शिक्षा १",
    "page_numbers": "146–152",
    "sentences": []
  },
  {
    "id": "grade8_app1",
    "fileName": "grade8_app1.txt",
    "title": "परिशिष्टम् १: व्याकरणम् — उपसर्गाः, प्रत्ययाः, कारकाणि, सन्धयः",
    "page_numbers": "159–165",
    "sentences": []
  },
  {
    "id": "grade8_app2",
    "fileName": "grade8_app2.txt",
    "title": "परिशिष्टम् २: शब्दरूपाणि — नामपदानि, सर्वनामपदानि, संख्यावाचकपदानि च",
    "page_numbers": "166–175",
    "sentences": []
  },
  {
    "id": "grade8_app3",
    "fileName": "grade8_app3.txt",
    "title": "परिशिष्टम् ३: धातुरूपाणि — लट्, लृट्, लङ्, लोट्, विधिलिङ्-लकाराः (परस्मैपदम् आत्मनेपदम् च)",
    "page_numbers": "176–185",
    "sentences": []
  },
  {
    "id": "grade9_prarthana",
    "fileName": "grade9_prarthana.txt",
    "title": "Grade 9: सरस्वतीप्रार्थना एवं राष्ट्रगीतम् (Pages 12 & 18)",
    "page_numbers": "Pages 12 & 18",
    "sentences": []
  },
  {
    "id": "grade9_ch1",
    "fileName": "grade9_ch1.txt",
    "title": "Grade 9: प्रथमः पाठः — सत्यं शिवं सुन्दरं संस्कृतम् (Pages 1–8)",
    "page_numbers": "Pages 1–8",
    "sentences": []
  },
  {
    "id": "grade9_ch2",
    "fileName": "grade9_ch2.txt",
    "title": "Grade 9: द्वितीयः पाठः — सुखस्य मूलं धर्मः, धर्मस्य मूलम् अर्थः (Pages 9–21)",
    "page_numbers": "Pages 9–21",
    "sentences": []
  },
  {
    "id": "grade9_ch3",
    "fileName": "grade9_ch3.txt",
    "title": "Grade 9: तृतीयः पाठः — आत्मवत्सर्वभूतेषु यः पश्यति सः पण्डितः (Pages 22–37)",
    "page_numbers": "Pages 22–37",
    "sentences": []
  },
  {
    "id": "grade9_ch4",
    "fileName": "grade9_ch4.txt",
    "title": "Grade 9: चतुर्थः पाठः — न खलु वयस्तेजसो हेतुः (Pages 38–49)",
    "page_numbers": "Pages 38–49",
    "sentences": []
  },
  {
    "id": "grade9_ch5",
    "fileName": "grade9_ch5.txt",
    "title": "Grade 9: पञ्चमः पाठः — एषा सा कृतकबुद्धिः मानवबुद्धेः सहकरी (Pages 51–66)",
    "page_numbers": "Pages 51–66",
    "sentences": []
  },
  {
    "id": "grade9_ch6",
    "fileName": "grade9_ch6.txt",
    "title": "Grade 9: षष्ठः पाठः — मनःपूतं समाचरेत् (Pages 67–78)",
    "page_numbers": "Pages 67–78",
    "sentences": []
  },
  {
    "id": "grade9_ch7",
    "fileName": "grade9_ch7.txt",
    "title": "Grade 9: सप्तमः पाठः — उपायं चिन्तयेत् प्राज्ञस्तथापायं च चिन्तयेत् (Pages 79–91)",
    "page_numbers": "Pages 79–91",
    "sentences": []
  },
  {
    "id": "grade9_ch8",
    "fileName": "grade9_ch8.txt",
    "title": "Grade 9: अष्टमः पाठः — अन्नाद् आनन्दं प्रति (Pages 92–111)",
    "page_numbers": "Pages 92–111",
    "sentences": []
  },
  {
    "id": "grade9_ch9",
    "fileName": "grade9_ch9.txt",
    "title": "Grade 9: नवमः पाठः — कृतं प्रतिकृतं भूयादेष धर्मः सनातनः (Pages 112–126)",
    "page_numbers": "Pages 112–126",
    "sentences": []
  },
  {
    "id": "grade9_ch10",
    "fileName": "grade9_ch10.txt",
    "title": "Grade 9: दशमः पाठः — णमो अरिहन्ताणम् (Pages 127–144)",
    "page_numbers": "Pages 127–144",
    "sentences": []
  },
  {
    "id": "grade9_ch11",
    "fileName": "grade9_ch11.txt",
    "title": "Grade 9: एकादशः पाठः — वर्णोच्चारण-शिक्षा २ (Pages 145–160)",
    "page_numbers": "Pages 145–160",
    "sentences": []
  },
  {
    "id": "grade9_ch12",
    "fileName": "grade9_ch12.txt",
    "title": "Grade 9: द्वादशः पाठः — अन्वय-शिक्षा (Pages 161–176)",
    "page_numbers": "Pages 161–176",
    "sentences": []
  },
  {
    "id": "grade9_samasa",
    "fileName": "grade9_samasa.txt",
    "title": "Grade 9: परिशिष्टम् २ — समास-प्रकरणम् (Pages 177–195)",
    "page_numbers": "Pages 177–195",
    "sentences": []
  },
  {
    "id": "grade9_vachya",
    "fileName": "grade9_vachya.txt",
    "title": "Grade 9: परिशिष्टम् ३ — वाच्य-परिवर्तनम् (Pages 196–215)",
    "page_numbers": "Pages 196–215",
    "sentences": []
  },
  {
    "id": "grade9_shabda",
    "fileName": "grade9_shabda.txt",
    "title": "Grade 9: परिशिष्टम् ४ — शब्दरूपाणि (Pages 216–228)",
    "page_numbers": "Pages 216–228",
    "sentences": []
  },
  {
    "id": "grade9_dhatu",
    "fileName": "grade9_dhatu.txt",
    "title": "Grade 9: परिशिष्टम् ५ — धातुरूपाणि (Pages 229–244)",
    "page_numbers": "Pages 229–244",
    "sentences": []
  }
];
